module.exports = __webpack_public_path__ + "static/media/tribe_bg.888e7e66.jpeg";